var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "mb-0" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mt-1", attrs: { cols: "12" } },
                [_c("InvoiceList")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }